// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"331":"19362b003586ec14","651":"3157f8df6090560f"}[chunkId] + ".js";
};